<template>
  <div>
    <v-row dense>
      <v-col cols="1" class="mt-2">{{ this.tag }}</v-col> 
      <v-col cols="1" v-for="(day, i) in days" :key="i" align="left">
        <v-text-field 
          reverse 
          dense 
          v-model="days[i]" 
          v-on:focus="getFocus($event)" 
          v-on:keydown="isNumber($event)" 
          v-on:change="callChange()" 
          class="v-text-field-width">
        </v-text-field>          
      </v-col>      
      <v-col cols="4" v-if="checkbox_show">
        <v-checkbox 
          :label="checkbox_label" 
          dense 
          hide-details 
          :value="checkbox_value"
          v-on:change="callChangeCheckBox"></v-checkbox>
      </v-col>
      <v-col>
        <div v-if="info!==''" :class="`${fontsize}`" v-html="info"></div>
      </v-col>          
    </v-row>    
  </div>
</template>

<script>
  export default {
    props: {
      days: Array,
      field: String, 
      tag: String,
      checkbox_field: String,
      checkbox_show: Boolean,
      checkbox_value: Boolean,
      checkbox_label: String,    
      info: String,
      info_font_size: String,             
    },
    data() {
      return {
          fontsize: "font-size-" + this.info_font_size,
      }
    },       
    methods:{
      isNumber (evt) {      
        let selection = evt.target.value.substring(
          evt.target.selectionStart,
          evt.target.selectionEnd
        );
        let keysAllowed = [];
        if(evt.target.value.length===1 && selection.length!==1){
          keysAllowed = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
        } else {
          keysAllowed = ['0', '2', '3', '4', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
        }
        if (!keysAllowed.includes(evt.key)) {
          evt.preventDefault()
        }
      }, 
      getFocus(evt){
        try{
          evt.target.select();
        } catch(err){ 
          console.log(err);
        }
      },
      callChangeCheckBox(data){
        //console.log(data===null ? false : true);
        this.$emit('updateData', {"field": this.checkbox_field, "value": data===null ? false : true});
      },
      callChange(){        
        this.$emit('updateData', {"field": this.field, "value": this.days});
      },         
    }
  }
</script>

<style scoped>
  .v-text-field-width{
      width: 20px;
  }
  .font-size-small{
    font-size:small;
  }
  .font-size-medium{
    font-size:medium;
  }
  .font-size-large{
    font-size:large;
  }  
</style>